import { IAction, StateStatus } from '../../utils/common';
import * as Types from './types';

interface IState {
  OSSSchemesList: any;
  countriesList: any;
  importCountries: any;
  registerUserStatus: StateStatus | null | undefined;
}

const initialState: IState = {
  OSSSchemesList: {
    status: null,
    data: null,
  },
  importCountries: {
    status: null,
    data: null,
  },
  registerUserStatus: null,
  countriesList: {
    status: null,
    data: null,
  },
};

const RegisterReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_OSS_SCHEMES:
      return {
        ...state,
        OSSSchemesList: {
          ...state.OSSSchemesList,
          status: action.status,
          data: action.data,
        },
      };
    case Types.SET_COUNTRIES:
      return {
        ...state,
        countriesList: {
          ...state.countriesList,
          status: action.status,
          data: action.data,
        },
      };
    case Types.REGISTER_USER:
      return {
        ...state,
        registerUserStatus: action.status,
      };
    case Types.SET_COUNTRIES_NOT_IN_STATE_IMSID:
      return {
        ...state,
        importCountries: {
          ...state.importCountries,
          status: action.status,
          data: action.data,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default RegisterReducer;
